export interface ErrorResponse {
    statusCode: number;
    message?: string | undefined;
}

export function isErrorResponse(value: unknown): value is ErrorResponse {
    return (
        typeof value === "object" && value !== null &&
        typeof (value as ErrorResponse).statusCode === "number" &&
        (typeof (value as ErrorResponse).message === "string" || typeof (value as ErrorResponse).message === "undefined")
    );
}